import EventEmitter from 'eventemitter3';
import * as PIXI from 'pixi.js';

export interface Setting {
  t1: number;
  t2: number;
  s: number;
}

export class UpDownController extends EventEmitter<{
  change: [number];
}> {
  private container = new PIXI.Container();
  private up = new PIXI.Graphics();
  private down = new PIXI.Graphics()

  constructor(width: number, height: number) {
    super();
    /*
    this.down.lineStyle(1, 0x5dffff)
      .moveTo(0, height / 2 + 2)
      .lineTo(width, height / 2 + 2)
      .lineTo(width / 2, height)
      .lineTo(0, height / 2 + 2);
    */

    /*
    this.up.lineStyle(1, 0x5dffff)
      .moveTo(0, height / 2 - 2)
      .lineTo(width, height / 2 - 2)
      .lineTo(width / 2, 0)
      .lineTo(0, height / 2 - 2);
    */
    this.down.beginFill(0x5dFFFF);
    this.down.drawPolygon(
      [0, height / 2 + 2, width, height / 2 + 2, width / 2, height, 0, height / 2 + 2],
    );
    this.down.endFill();

    this.up.beginFill(0x5dFFFF);
    this.up.drawPolygon(
      [0, height / 2 - 2, width, height / 2 - 2, width / 2, 0, 0, height / 2 - 2],
    );
    this.up.endFill();

    this.down.interactive = true;
    this.down.buttonMode = true;
    this.down.on('pointerdown', (e: PIXI.InteractionEvent) => {
      if (e.data.originalEvent.shiftKey) {
        this.emit('change', -10);
        return;
      }
      this.emit('change', -1);
    });
    this.up.interactive = true;
    this.up.buttonMode = true;
    this.up.on('pointerdown', (e: PIXI.InteractionEvent) => {
      if (e.data.originalEvent.shiftKey) {
        this.emit('change', 10);
        return;
      }
      this.emit('change', 1);
    });

    this.container.addChild(this.up, this.down);
  }

  public getContainer() {
    return this.container;
  }
}
